"use strict";
// MIT License
Object.defineProperty(exports, "__esModule", { value: true });
exports.b2_maxPolygonVertices = exports.b2_lengthUnitsPerMeter = void 0;
// Copyright (c) 2019 Erin Catto
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
// Tunable Constants
// TODO: Make this overridable by user as box2d allows it too.
/**
 * You can use this to change the length scale used by your game.
 * For example for inches you could use 39.4.
 */
exports.b2_lengthUnitsPerMeter = 1;
/**
 * The maximum number of vertices on a convex polygon. You cannot increase
 * this too much because b2BlockAllocator has a maximum object size.
 */
exports.b2_maxPolygonVertices = 8;
